import React, { useState, useEffect } from "react";
import axios from "axios";
import jsonpAdapter from "axios-jsonp";
import { useTranslation } from "react-i18next";
import { Modal, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { signupUser } from "../../redux/actions/authActons";
import api from "../../services/api";
import { useHistory } from "react-router-dom";

const API_IBGE_URL = "https://servicodados.ibge.gov.br/api/v1/localidades";

//TEmporario
const initForm = {
  email: "",
  razao: "",
  fantasia: "",
  responsavel: "",
  cnpj: "",
  telefone: "",
  celular: "",
  cep: "",
  logradouro: "",
  bairro: "",
  cidade: "",
  uf: "",
  usuario: "",
  senha: "",
  senhaN: "",
};



function Registro(props) {
  const history = useHistory();

  const [cnpj, setCnpj] = useState("");

  const [empresa, setEmpresa] = useState(initForm);
  const [municipios, setMunicipios] = useState([]);
  const [estados, setEstados] = useState([]);

  const [erros, setErros] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [showModal, setShowModal] = useState(false);
  
  useEffect(() => {
    async function getEstados() {
      api
        .get("/uteis/uf")
        .then((res) => {
          const data = res.data.Ufs;
          console.log(data);
          setEstados(data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
    getEstados();
  }, []);

  useEffect(() => {
    async function getMunicipios(uf) {
      axios
        .get(`${API_IBGE_URL}/estados/${uf}/municipios`)
        .then((res) => {
          const { data } = res;
          console.log(data);
          setMunicipios(data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
    if (empresa.uf && empresa.uf !== "Selecionar") {
      getMunicipios(empresa.uf);
    }
  }, [empresa.uf]);

  function handleChange(e) {
    const { name, value } = e.target;
    setEmpresa({ ...empresa, [name]: value });
  }

  async function handleRegistro(e) {
    e.preventDefault();

    const valid = validar();

    if (valid) {
      api.post('/cadastro/cliente', {...empresa}).then(res => {
        const {resultado} = res.data;
        console.log(resultado);
        if(resultado=== 'true'){
          handleModal(true)
        }else{
          handleModal(false, 'Já existe um cadastro com esse CNPJ')
        }
        
      }).catch(err => {
        console.log('Erro ao registrar novo cliente', err)
      })
    }
  }

  function validarCNPJ(cnpj) {
    const regex = /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}\-?\d{2}$/;
    console.log(regex.test(cnpj))
    return regex.test(cnpj);
  }

  function removeCaracteres(cnpj){
    return cnpj.replace(/[^\d]+/g, '');
  }

  function consultarCNPJ(cnpj) {
    if (validarCNPJ(cnpj)) {
      axios({
        url: `https://www.receitaws.com.br/v1/cnpj/${cnpj}`,
        adapter: jsonpAdapter,
      })
        .then((res) => {
          console.log(res);
          const { data } = res;
          if (data.status === "ERROR") {
            handleModal(false, data.message);
          } else {
            const dados = {
              email: data.email,
              nome: data.nome,
              fantasia: data.fantasia,
              cnpj: removeCaracteres(data.cnpj),
              telefone: removeCaracteres(data.telefone),
              cep: removeCaracteres(data.cep),
              logradouro: data.logradouro,
              bairro: data.bairro,
              cidade: data.municipio,
              uf: data.uf,
            };
            setEmpresa(dados);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }else{
      handleModal(false, "Por favor, digite um CNPJ válido");
    }
  }

  function validar() {
    let valid = false;
    if (!empresa.cnpj) {
      handleModal(false, "CNPJ obrigatório");
    } else if (!empresa.nome) {
      handleModal(false, "Razão social obrigatório");
    } else if (!empresa.fantasia) {
      handleModal(false, "Nome fantasia obrigatório");
    } else if (!empresa.email) {
      handleModal(false, "Email obrigatório");
    } else if (!empresa.logradouro) {
      handleModal(false, "Endereço obrigatório");
    } else if (!empresa.uf) {
      handleModal(false, "UF obrigatório");
    } else if (!empresa.cidade) {
      handleModal(false, "Cidade obrigatório");
    } else if (!empresa.usuario) {
      handleModal(false, "Por favor, digite o nome do usuario");
    } else if (!empresa.senha) {
      handleModal(false, "Por favor, escolha uma senha para o E-mail");
    }else if(!validarCNPJ(empresa.cnpj)) {
      handleModal(false, "Por favor, digite um CNPJ válido");
    }else {
      valid = true;
    }

    return valid;
  }

  function handleModal(
    sucess,
    msg = "Falha ao criar cadastro. Tente novamente"
  ) {
    if (sucess) {
      setMensagem("Cadastro realizado com sucesso");
    } else {
      setErros(true);
      setMensagem(msg);
    }
    setShowModal(true);
  }

  function handleCloseModal() {
    if (erros) {
      setShowModal(false);
      setErros(false);
    } else {
      history.push("/dashboard");
    }
  }

  return (
    <div>
      <div
        className="d-flex align-items-center auth px-0"
        style={{ marginTop: 100 }}
      >
        <div className="row w-100 mx-0">
          <div className="col-lg-8 mx-auto">
            <div className="auth-form-light text-left py-5 px-4 px-sm-5">
              <div className="brand-logo">
                <img
                  src={require("../../assets/images/Ativo-8@4x.png")}
                  style={{ width: "60px", height: "60px" }}
                  alt="logo"
                />
              </div>
              <br />
              <h4>Novo aqui?</h4>
              <h6 className="font-weight-light">
                O Registro é fácil. Leva apenas alguns passos
              </h6>
              <br />
              <div className="row d-flex justify-content-center justify-content-md-between   flex-wrap">
                <div className="col-xl-12 col-lg-12 col-sm-12  grid-margin stretch-card">
                  <div className="">
                    <div className="row">
                      <div className="col-mx-4">
                        <label className="col">CNPJ</label>
                        <div class="input-group ">
                          <Form.Control
                            name="cnpj"
                            value={empresa.cnpj}
                            className="col"
                            type="text"
                            maxLength={14}
                            onChange={handleChange}
                            autoFocus
                            required
                          />

                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              onClick={(e) => consultarCNPJ(empresa.cnpj)}
                            >
                              Buscar
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col">Razão social</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.nome}
                            onChange={handleChange}
                            name="nome"
                            className="col"
                            type="text"
                          />
                        </Form.Group>
                      </div>
                    </div>

                    <div>
                      <div>
                        <label>Nome de fantasia</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.fantasia}
                            onChange={handleChange}
                            name="fantasia"
                            className="col"
                            type="text"
                          />
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      
                      <div className="col-md-3">
                        <label>Celular</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.celular}
                            onChange={handleChange}
                            name="celular"
                            className="col"
                            maxLength={11}
                            type="cel"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3">
                        <label>Telefone</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.telefone}
                            onChange={handleChange}
                            name="telefone"
                            className="col"
                            maxLength={11}
                            type="cel"
                          />
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <Form.Group>
                          <label>Endereço</label>
                          <Form.Control
                            value={empresa.logradouro}
                            onChange={handleChange}
                            name="logradouro"
                            className="col"
                            type="text"
                          />
                        </Form.Group>
                      </div>

                      <div className="col-md-3">
                        <Form.Group>
                          <label htmlFor="ufInput">UF</label>
                          <select
                            value={empresa.uf}
                            onChange={handleChange}
                            name="uf"
                            className="form-control"
                            id="ufInput"
                          >
                            <option>Selecionar</option>
                            {estados.map((item, idx) => (
                              <option value={item.UF}>{item.UF}</option>
                            ))}
                          </select>
                        </Form.Group>
                      </div>
                      <div className="col-md-3">
                        <Form.Group>
                          <label htmlFor="cidadeInput">Cidade</label>
                          <select
                            value={empresa.cidade}
                            onChange={handleChange}
                            name="cidade"
                            className="form-control"
                            id="ufInput"
                          >
                            <option>Selecionar</option>
                            {municipios.map((item, idx) => (
                              <option value={(item.nome).toUpperCase()}>{(item.nome).toUpperCase()}</option>
                            ))}
                          </select>
                        </Form.Group>
                      </div>

                      <div className="col-md-6">
                        <label className="col">Nome do usuário:</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.usuario}
                            onChange={handleChange}
                            className="col"
                            name="usuario"
                            type="text"
                            maxLength={10}
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <label className="col">E-mail:</label>
                        <Form.Group>
                          <Form.Control
                          value={empresa.email}
                          onChange={handleChange}
                          name="email"
                          className="col"
                          type="text"
                            
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3">
                        <label>Senha:</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.senha}
                            onChange={handleChange}
                            className="col"
                            name="senha"
                            type="password"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-4">
                        <label>Senha Novamente:</label>
                        <Form.Group>
                          <Form.Control
                            value={empresa.senhaN}
                            onChange={handleChange}
                            className="col"
                            name="senhaN"
                            type="password"
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <button
                      onClick={handleRegistro}
                      className="btn btn-primary"
                    >
                      Salvar
                    </button>
                    <button
                    style={{marginLeft: '5px'}}
                      onClick={(e) => window.location.href = '/login'}
                      className="btn btn-secondary"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
              {/*<Form className="pt-3">
                <Form.Group>
                  
                    <Form.Control.Feedback style={{display: "block"}} type="invalid">
                  
                    </Form.Control.Feedback>
                  }
                </Form.Group>
                <Form.Group className="search-field">
                  <Form.Control 
                    type="email" 
                    placeholder="Email" 
                   
                    size="lg" 
                   
                    className="h-auto" />
                  <Form.Control.Feedback type="invalid">
                  
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="search-field">
                  <Form.Control 
                    type="password" 
                    placeholder="Senha" 
                   
                    size="lg" 
                   
                    className="h-auto" />
                  <Form.Control.Feedback type="invalid">
                   
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="search-field">
                  <Form.Control 
                    type="email" 
                    placeholder="Confirma senha" 
                   
                    size="lg" 
                   
                    className="h-auto" />
                  <Form.Control.Feedback type="invalid">
                   
                  </Form.Control.Feedback>
                </Form.Group>
                <div className="mb-4">
                  <div className="form-check">
                    <label className="form-check-label text-muted">
                      <input type="checkbox" className="form-check-input" />
                      <i className="input-helper"></i>
                      Eu concordo com todos os Termos e Condições
                    </label>
                  </div>
                </div>
                <div className="mt-3">
                  <Button 
                   
                    className="d-flex  align-items-center justify-content-center btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" >
                   
                    INSCREVER-SE
                  </Button>
                </div>
                <div className="text-center mt-4 font-weight-light">
                  Já tem uma conta?<Link to="/user-pages/login-1" className="text-primary">Login</Link>
                </div>
              </Form>
               */}{" "}
              {/* <div className="form-group">
                  <input type="text" className="form-control form-control-lg" id="exampleInputUsername1" placeholder="Username" />
                </div> */}
              {/* <div className="form-group">
                  <select className="form-control form-control-lg" id="exampleFormControlSelect2">
                    <option>Country</option>
                    <option>United States of America</option>
                    <option>United Kingdom</option>
                    <option>India</option>
                    <option>Germany</option>
                    <option>Argentina</option>
                  </select>
                </div> */}
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Mensagem</Modal.Title>
          </Modal.Header>
          <Modal.Body>{mensagem}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCloseModal}>
              Está bem
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.UI.loading,
  errors: state.UI.errors,
});
const mapActionsToProps = {
  signupUser,
};
export default connect(mapStateToProps, mapActionsToProps)(Registro);
